export default __webpack_public_path__ + "static/media/04.3fe528a7.jpg";